import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeineKontakteComponent } from './meine-kontakte/meine-kontakte.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MeineKontakteDialogComponent } from './meine-kontakte-dialog/meine-kontakte-dialog.component';

@NgModule({
    declarations: [MeineKontakteComponent, MeineKontakteDialogComponent],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatCardModule,
    ],
    exports: [MeineKontakteComponent, MeineKontakteDialogComponent],
})
export class MeineKontakteModule {}
